import React, { FC } from 'react'
import { WebRendererStatus } from '@sketch-hq/sketch-web-renderer'
import LoadingState from 'modules/shares/components/LoadingState'
import { PageCanvasError } from '../PageCanvasError'
import { getErrorDescription, getLoadingMessage } from '../../utils'

type PageCanvasStatusProps = {
  status: WebRendererStatus | null
}

export const PageCanvasStatus: FC<PageCanvasStatusProps> = props => {
  const { status } = props

  if (
    !status ||
    status.type === 'IDLE' ||
    status.type === 'INITIALIZING' ||
    status.type === 'LOADING_FILE' ||
    status.type === 'FILE_READY' ||
    status.type === 'DRAWING_FILE'
  ) {
    return <LoadingState message={getLoadingMessage(status)} />
  }

  if (status.type === 'FAILURE' || status.type === 'WEBGL_CONTEXT_LOST') {
    return (
      <PageCanvasError
        showReloadCanvasAction
        description={getErrorDescription(status)}
      />
    )
  }

  return null
}
